<template>
  <div>
    <nav-header></nav-header>
    <router-view></router-view>
    <nav-footer
      
      :phone="this.phone"
      :name="this.name"
      :addr="this.addr"
      :icp="this.icp"
    ></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "home",
  components: {
    NavFooter,
    NavHeader,
  },
  mounted() {
    document.title = "北京点悦互动软件科技有限公司  ";
  },
  data() {
    return {
      email: '邮箱：bihf@1yongcloud.com',
      phone: "",
      icp: "备案号：京ICP备2022031497号-1",
      name: "北京元测科技有限公司",
      addr: "地址：北京市朝阳区广顺北大街33号院1号楼5层",
    };
  },
};
</script>
<style lang='' scoped>
</style>